<template>
    <select :value="$store.state.sortSelected" @change="changeOption">
        <option disabled value="">{{ insert.defaultOption }}</option>
        <option
            v-for="option in this.options"
            :key="option.value"
            :value="option.value"
            >
            {{ option.name }}            
            </option>
    </select>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: String,

        },
        options: {
            type: Array,
            default: () => []
        },
        insert: {
            type: Object,
            required: true
        },
    },
    methods: {
        changeOption(event) {
            this.$emit('updateSelect', event.target.value)
        }
    },
}
</script>

<style scoped>

</style>